"use client";

import { Button } from "./button";
import { useCreateForm } from "@/hooks/provider/use-create-form";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useRouter } from "next/navigation";
import { useFormDetails } from "@/hooks/provider/use-form-details";
import { useViewportHeight } from "@/hooks/respondent/use-viewport-height";

export function Header(props: { variant: "dashboard" | "form" | "results" }) {
  const { createForm, loading, name, disabled } = useCreateForm();
  const router = useRouter();
  const toDashboard = () => router.push("/dashboard");

  return (
    <header className="h-12 w-full flex justify-between items-center px-5">
      <div className="flex items-center gap-2">
        {props.variant === "form" ? (
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="ghost">내 폼</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>폼을 저장하지 않고 나갈까요?</DialogTitle>
                <DialogDescription>
                  폼을 게시하지 않고 나가면 작성된 내용이 모두 사라져요.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <DialogClose asChild>
                  <Button type="button" variant="secondary">
                    계속 작성하기
                  </Button>
                </DialogClose>
                <Button
                  type="button"
                  variant="destructive"
                  onClick={toDashboard}
                >
                  대시보드로 돌아가기
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        ) : (
          <Button variant="ghost" onClick={toDashboard}>
            내 폼
          </Button>
        )}
        {props.variant !== "dashboard" && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
            >
              <path
                d="M1 1L6 6L1 11"
                stroke="#D4D4D4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="text-14m text-opacity-600 px-[10px] py-[7px] truncate overflow-hidden flex-grow max-w-[300px]">
              {name ?? "새 폼"}
            </div>
          </>
        )}
      </div>
      {props.variant === "form" && (
        <div className="flex items-center gap-3">
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="secondary">나가기</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>폼을 저장하지 않고 나갈까요?</DialogTitle>
                <DialogDescription>
                  폼을 게시하지 않고 나가면 작성된 내용이 모두 사라져요.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <DialogClose asChild>
                  <Button type="button" variant="secondary">
                    계속 작성하기
                  </Button>
                </DialogClose>
                <Button
                  type="button"
                  variant="destructive"
                  onClick={toDashboard}
                >
                  나가기
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

          <Dialog>
            <DialogTrigger asChild>
              <Button id="publish-form-button" disabled={disabled}>
                게시하기
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>폼을 정말 게시할까요?</DialogTitle>
                <DialogDescription>
                  한번 폼을 게시하면 더이상 작성된 내용을 수정할 수 없어요.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <DialogClose asChild>
                  <Button type="button" variant="secondary">
                    계속 작성하기
                  </Button>
                </DialogClose>
                <Button
                  type="button"
                  onClick={createForm}
                  loading={loading}
                  disabled={disabled}
                  id="confirm-publish-form-button"
                >
                  게시하기
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      )}
    </header>
  );
}

export function RespondentHeader() {
  const { form } = useFormDetails();
  useViewportHeight();

  return (
    <header className="px-3 py-2 bg-white text-20sb border-b border-gray-100 flex items-center justify-center">
      <div className="text-gray-700 text-17m">{form?.name || "챗폼"}</div>
    </header>
  );
}
